import * as Models from "../.";
export interface ISearchSolarAccountsResponse {
  solarAccounts: Array<Models.Customer.SolarAccountResponse.ISolarAccountResponse>;
}

export class SearchSolarAccountsResponse
  implements ISearchSolarAccountsResponse {
  solarAccounts: Array<Models.Customer.SolarAccountResponse.ISolarAccountResponse>;
}
